class PickupController {
    /*@ngInject*/
    constructor($rootScope, CommonService, AddToCartService, ProductDetailService) {
        this.addToCartService = AddToCartService;
        this.productDetailService = ProductDetailService;
        this.CommonService = CommonService;

        $rootScope.$on('addToCartSuccess', () => {
            window.location.href = this.CommonService.getBaseUrl() + '/cart';
        });

        if (window.cities) {
            this.cities = window.cities.cities;
        }
        this.selectedCity = '';
        this.city = {
            selected: null
        };
        this.requestPending = false;
    }

    cityChanged(item) {
        this.selectedCity = item.code;
    }

    setCityCode(code) {
        this.selectedCity = code;
        for (let entry of this.cities) {
            if (code === entry.code) {
                this.city.selected = entry;
                break;
            }
        }
    }

    submit(form) {
        this.requestPending = true;
        form.$$element.submit();
    }
}

export default PickupController;
